import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { PATH_ORDER_LIST } from '@/router/path';
import { getPath } from '@/scripts/utils';
import Cookies from 'js-cookie';
import { COOKIE_TOKEN } from '@/scripts/config';

export default function Landing() {
    const navigate = useNavigate();
    const token = Cookies.get(COOKIE_TOKEN) || '';
    useEffect(() => {
        // token ? navigate(getPath([PATH_ORDER_LIST])) : navigate('/login');
        navigate(getPath([PATH_ORDER_LIST]));
    }, []);

    return null;
}
